import declare from "dojo/_base/declare";
import ProductHierarchyFolderForm from "./ProductHierarchyFolderForm";
import CopyProductHierarchyLevelMixin from "./CopyProductHierarchyLevelMixin";

const CopyProductHierarchyFolderForm = declare([ProductHierarchyFolderForm, CopyProductHierarchyLevelMixin], {
});

export = CopyProductHierarchyFolderForm;